import { PdpDesktopDetailRow } from './PdpDesktopDetailRow';
import { formatPdpCarat } from '@/features/pdp/utils/formatPdpCarat';
import type { ProductStoneDetailsInput } from '@/features/pdp/utils/productDetailStones';
import {
  getDiamondSummaryLabel,
  hasDiamondDetails,
} from '@/features/pdp/utils/productDetailStones';

const WEIGHT_VARIATION_TEXT =
  'The final invoice amount will be adjusted in case of variation in weight.';

interface PdpDesktopStoneDetailsAnalyticsProps {
  onInfoIconClick?: (label: string) => void;
}

export function PdpDesktopDiamondDetailsSummary({
  onInfoIconClick,
  ...input
}: ProductStoneDetailsInput & PdpDesktopStoneDetailsAnalyticsProps) {
  if (!hasDiamondDetails(input)) {
    return null;
  }

  return (
    <>
      {input.diamondCarat ? (
        <PdpDesktopDetailRow
          label="Total Weight"
          value={`${formatPdpCarat(input.diamondCarat)} Ct`}
          tooltip={WEIGHT_VARIATION_TEXT}
          onInfoIconClick={onInfoIconClick}
        />
      ) : null}
      {input.noOfDiamonds ? (
        <PdpDesktopDetailRow label="Total No. Of Diamonds" value={input.noOfDiamonds} />
      ) : null}
    </>
  );
}

export function PdpDesktopDiamondDetailsExpanded(input: ProductStoneDetailsInput) {
  if (!hasDiamondDetails(input)) {
    return null;
  }

  const summaryLabel = getDiamondSummaryLabel(input);

  return (
    <>
      {summaryLabel ? <PdpDesktopDetailRow label="Stone Type" value={summaryLabel} /> : null}
    </>
  );
}
